module.exports = __webpack_public_path__ + "static/img/cmbLogo.f6f8634.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/ui/img/cmbLogo.jpeg
// module id = 2018
// module chunks = 148